
import { InjectionToken } from '@angular/core';

export const LoggedInUserMarketerToken = new InjectionToken('LoggedInUserMarketerToken');
